<template>
  <div class="house-importer-payment-info-panel">
    <app-panel title="Платежная ифнормация">
      <div slot="actions">
        <app-button color="success" :disabled="isSaving" @click="saveData">{{isSaving ? 'Сохраняю...' : 'Сохранить'}}</app-button>
      </div>

      <div>
        <div class="house-importer-payment-info-panel__row">
          <app-input label="Public Id" :disabled="isSaving" v-model="public_id"/>
        </div>
        <div class="house-importer-payment-info-panel__row">
          <app-input label="CP Pass" :disabled="isSaving" v-model="cp_pass"/>
        </div>
      </div>
    </app-panel>
  </div>
</template>

<script>
  export default {
    name: "PaymentInfoPanel",
    props: {
      importInfo: {}
    },
    data() {
      return {
        isSaving: false,
        public_id: null,
        cp_pass: null
      }
    },
    methods: {
      async saveData(){
        this.isSaving = true;
        try{
          let body = {
            import_id: this.importInfo.id,
            public_id: this.public_id,
            cp_pass: this.cp_pass
          };
          await this.$http.put('import/houses/payment_data', body);
          this.$vs.notify({color: 'success', title: 'Успешное обновление', text: 'Платежная информация успешно обновлена'});
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
        finally{
          setTimeout(() => {
            this.isSaving = false;
          }, 300);
        }

      },
      async updateData() {
        try {
          let {data} = await this.$http.get('import/houses/payment_data', {params: {import_id: this.importInfo.id}});
          this.public_id = data.public_id || null;
          this.cp_pass = data.cp_pass || null;
        } catch (e) {
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
      }
    },
    created() {
      this.updateData();
    }
  }
</script>

<style lang="scss">
.house-importer-payment-info-panel{

  &__row{
    margin-bottom: 15px;
  }

}
</style>